import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="scroll"
export default class extends Controller {
  static targets = ["stickyDiv", "toggler"];

  connect() {
    window.addEventListener("scroll", this.handleScroll.bind(this));
  }

  disconnect() {
    window.removeEventListener("scroll", this.handleScroll.bind(this));
  }

  handleScroll() {
    const scrollPosition = window.pageYOffset;
    const togglerOffset = this.togglerTarget.offsetTop;
    if (scrollPosition > togglerOffset) {
      this.stickyDivTarget.classList.remove("hidden");
      this.stickyDivTarget.classList.add("fix-under-navbar");
    } else {
      this.stickyDivTarget.classList.remove("fix-under-navbar");
      this.stickyDivTarget.classList.add("hidden");
    }
  }
}
